import { Container } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';

import { ITranslateStore } from '../stores/TranslateStore';

interface INotFoundProps {
  translateStore?: ITranslateStore;
}

@inject('translateStore')
@observer
class NotFound extends React.Component<INotFoundProps> {
  public render(): JSX.Element {
    const translate = this.props.translateStore.translate;
    return (
      <Container>
        <div className="text">
          <div className="text">
            <h1>{translate('shared.errors.404.title')}</h1>
            <p>{translate('shared.errors.404.text')}</p>
          </div>
        </div>
      </Container>
    );
  }
}

export default NotFound;
